// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadSimilarAlbumsAction } from '../../actions/album';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: string,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function similarAlbums(
  state: State = initialState,
  action: LoadSimilarAlbumsAction
): State {
  if (action.type === 'FETCH_SIMILAR_ALBUMS' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
